import React from 'react';
// import {Link} from 'react-router-dom';
import css from './Carousel.module.css';

function Carousel(props) {
    const carousel =()=>(
<React.Fragment>
<div id="carouselExampleIndicators" className={`carousel slide ${css.Carouselitem}`} data-ride="carousel">
  <ol className="carousel-indicators">
    <li data-target="#carouselExampleIndicators" data-slide-to="0" className="active"></li>
    <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
    <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
  </ol>
  <div className="carousel-inner ">
    <div className={`carousel-item active ${css.Carouselitem}`} >
      <img  src="https://nhathuoclongchau.com/upload/slide/1598417894-SAZJ-sinh-ly-noi-tiet-to-nam-nu.jpg" alt="First slide"/>
      {/* <div className="carousel-caption ">
    <h5>Product title</h5>
    <p>this is some caption of product</p>
  </div> */}
    </div>
    <div className={`carousel-item  ${css.Carouselitem}`} >
      <img  src="https://nhathuoclongchau.com/upload/slide/1601022659-Idzs-sp-ho-tro-he-tieu-hoa.png" alt="Second slide"/>
      {/* <div className="carousel-caption ">
    <h5>Product title</h5>
    <p>this is some caption of product</p>
  </div> */}
    </div>
    <div className={`carousel-item ${css.Carouselitem}`}>
      <img  src="https://nhathuoclongchau.com/upload/slide/1598847129-tP3E-tu-thuoc-gia-dinh.jpg" alt="Third slide"/>
      {/* <div className="carousel-caption ">
    <h5>Product title</h5>
    <p>this is some caption of product</p>
  </div> */}
    </div>
  </div>
  <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="sr-only">Previous</span>
  </a>
  <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
  <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="sr-only">Next</span>
  </a>
</div>
  </React.Fragment>
    )
    return (
       <React.Fragment>
           {carousel()}
       </React.Fragment>
    );
}

export default Carousel;
